import React, { useState } from "react";
import Layout from "../pages/Layout";
import "../css/UserDetail.css";
import { defaultAxiosInstance } from "../api/defaultInstance";

function UserRegister() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    //subscription: "월간구독", // 기본값 설정
    subscriptionType: "free", // 기본값 설정
    birthdate: "",
    subEndDate:""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    console.log(formData)
    
    if(!/^[0-9]{11}$/.test(formData.phoneNumber)) {
      alert("전화번호를 올바르게 입력해주세요.")
      return
    }

    if(!formData.name || !formData.email || !formData.birthdate) {
      alert("모든 정보를 입력해주세요.")
      return
    }


    try {
      const response = await defaultAxiosInstance.post("/admin/user", formData);
      console.log(response)
      alert("회원등록이 완료되었습니다.");
      console.log("회원정보:", response.data);
    } catch (error) {
      console.log(error.response.data)
      if(error.response.data.type == "/errors/phone_number_exist" || error.response.data.type == "/errors/conflict") {
        alert(error.response.data.detail);
      }else {
        alert("수정 중 오류가 발생했습니다. 다시 시도해주세요.");
      }
      
      console.error("회원 정보 수정 중 오류 발생:", error);
    }
  };

  return (
    <Layout>
      <div className="user-detail-container">
        {/* 타이틀 */}
        <h2 className="title">회원 등록</h2>

        {/* 회원 정보 테이블 */}
        <div className="info-table eight-by-two">
          {/* 이름 */}
          <div className="info-row2">
            <div className="info-label">이름</div>
            <div className="info-value">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
                placeholder="이름을 입력하세요"
              />
            </div>
          </div>
          {/* 생년월일 */}
          <div className="info-row2" onClick={() => document.getElementById("birthdate").focus()}>
            <div className="info-label">생년월일</div>
            <div className="info-value">
              <input
                type="date"
                id="birthdate" // ID를 추가
                name="birthdate"
                value={formData.birthdate}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>
          {/* 이메일 */}
          <div className="info-row2">
            <div className="info-label">이메일(가입 ID)</div>
            <div className="info-value">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                placeholder="이메일을 입력하세요"
              />
            </div>
          </div>
          {/* 연락처 */}
          <div className="info-row2">
            <div className="info-label">연락처</div>
            <div className="info-value">
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="form-control"
                placeholder="숫자만 입력 ex) 01012341234"
              />
            </div>
          </div>
          {/* 구독 종류 */}
          <div className="info-row2">
            <div className="info-label">구독 종류</div>
            <div className="info-value">
              <select
                name="subscription"
                value={formData.subscription}
                onChange={handleChange}
                className="form-select"
              >
                <option value="월간구독">월간구독</option>
                <option value="연간구독">연간구독</option>
              </select>
            </div>
          </div>
          {/* 멤버십 종류 */}
          <div className="info-row2">
            <div className="info-label">멤버십 종류</div>
            <div className="info-value">
              <select
                name="subscriptionType"
                value={formData.subscriptionType}
                onChange={handleChange}
                className="form-select"
              >
                <option value="free">Free</option>
                <option value="basic">Basic</option>
                <option value="standard">Standard</option>
                <option value="premium">Premium</option>
              </select>
            </div>
          </div>
          {/* 멤버십 종료일 */}
          <div className="info-row2" onClick={() => document.getElementById("subEndDate").focus()}>
            <div className="info-label">멤버십 종료일</div>
            <div className="info-value">
              <input
                type="date"
                id="subEndDate" // ID를 추가
                name="subEndDate"
                value={formData.subEndDate}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>
        </div>

        {/* 저장/취소 버튼 */}
        <div className="button-container">
          <button className="btn btn-primary" onClick={handleSave}>
            회원 등록 완료
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default UserRegister;
